(() => {
  const root = document.querySelector('#MainContent');
  if (!root) return;
  let pending = false;
  function enhance() {
    pending = false;
    const widget = root.querySelector('#judgeme_product_reviews');
    if (!widget) return;
    const list = widget.querySelector('.jdgm-review-list');
    if (list && !list.dataset.svpReady && list.querySelectorAll('.jm-review-item').length > 2) {
      list.dataset.svpReady = 'true';
      list.classList.add('svp-reviews-limited');
      const more = document.createElement('button');
      more.type = 'button';
      more.className = 'svp-reviews-expand';
      more.textContent = 'Show more reviews';
      more.setAttribute('aria-expanded', 'false');
      more.addEventListener('click', () => {
        list.classList.remove('svp-reviews-limited');
        more.remove();
      });
      list.after(more);
    }
    widget.querySelectorAll('.jm-review-content__body').forEach((body) => {
      const wrapper = body.closest('.jm-review-body-wrapper');
      if (!wrapper || wrapper.querySelector('button') || body.dataset.svpMore) return;
      body.dataset.svpMore = 'true';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'svp-review-more';
      button.textContent = 'More';
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', () => {
        const expanded = body.classList.toggle('svp-review-expanded');
        body.closest('.jm-review-item').classList.toggle('svp-review-open', expanded);
        button.textContent = expanded ? 'Less' : 'More';
        button.setAttribute('aria-expanded', String(expanded));
      });
      wrapper.append(button);
    });
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(enhance); } }
  new MutationObserver(schedule).observe(root, { childList:true, subtree:true });
  window.addEventListener('resize', schedule);
  document.fonts.ready.then(schedule);
  schedule();
})();